<template>
  <v-container>
    <v-row>
      <v-col class="pa-0">
        <v-img
          :src="require('../assets/wine1.jpg')"
          max-height="700px"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-0 pic-desc">
        <div>
          ABOUT US
        </div>
        <p >
          Founded in the late 1950's, Lorence & Co was one of <span class="special-text">the leading importers of Italian groceries</span> in Hong Kong.
        </p>
        <p>
          At present, Lorence carries <span class="special-text">over 70 Italian brands</span> of groceries. Lorence has been the <span class="special-text">sole distributors</span> of these brands in Hong Kong for more than 40<br>
          years. Over these years, Lorence has built up a trusted network its suppliers to ensure <span class="special-text">a healthy and reliable balance of quality, safety and price</span>
        </p>
        <p>
          With more than <span class="special-text">70 years of in-dept experiences</span> and knowledge of the local markets, Lorence delivers a wide variety of high-quality products to<br>
          restaurants, hotels, supermarket, airlines, catering and gourmet shops.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <div class="title">OUR LEADERSHIP</div>
    </v-row>
    <v-row style="justify-content: center;
      align-items: center;">
      <div class="img-left">
        <v-img
          :src="require('../assets/man2.jpg')"
        >
        </v-img>
        <div class="img-title-left">
          OUR FOUNDER
        </div>
        <div class="img-name-left">
          Madam Mang Mee Yee
        </div>
      </div>
      <v-divider vertical style="border-color: white;"></v-divider>
      <div class="img-right">
        <v-img
          :src="require('../assets/man1.jpg')"
        >
        </v-img>
        <div class="img-title-right">
          OUR CEO
        </div>
        <div class="img-name-right">
          Mr.Steven Chan
        </div>
      </div>
    </v-row>
    <v-row>
      <div class="title">OUR SERVICES</div>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-img
          :src="require('../assets/wine1.jpg')"
        />
      </v-col>
      <v-col class="pa-0 pic-desc">
        <div class="pic-desc-container">
          <p>
            To date,Lorence is not only the leading importer of Italian groceries in Hong Kong. It has its <span class="special-text">own logistics team</span>, <span class="special-text">own packaging facilities</span>, 
            <span class="special-text">refrigerated warehouse</span>, as well as a <span class="special-text">fleet of refrigerated delivery tructs</span>.
          </p>
          <p>
            Most importantly, Lorence is holding a <span class="special-text">good standing Food Factory License</span> duly certified by the Hong Kong SAR Government.
          </p>
          <p>
            With the said Food Factory License, Lorence <span class="special-text">provide packaging, slicing and food 
            processing services</span> to their customers.
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="title">OUR LOGOS</div>
    </v-row>
    <v-row style="justify-content: center;">
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
      <v-img
        max-height="100px"
        :src="require('../assets/logo.png')"
      />
    </v-row>
  </v-container>
</template>

<script>
 
  export default {
    name: 'Company',
    components: {
    },
    data: () => ({
      "cc": {
      }
    }),
  }
</script>

<style scoped>
.special-text{
  color: red;
}
.pic-desc{
  color: white;
  background-color: #19442A;
}
.title{
  color: white;
  margin: auto;
}
.img-left{
  position: relative;
  max-width: 23%;
  margin: 3%;
  margin-top: 0px;
}
.img-right{
  position: relative;
  max-width: 23%;
  margin: 3%;
  margin-top: 80px;
}
.img-title-left{
  position: absolute;
  top: 10%;
  left: -37%;
  color: white;
}
.img-name-left{
  position: absolute;
  top: 17%;
  left: -37%;
  color: white;
}
.img-title-right{
  white-space: nowrap;
  position: absolute;
  top: 80%;
  left: 80%;
  color: white;
}
.img-name-right{
  white-space: nowrap;
  position: absolute;
  top: 87%;
  left: 80%;
  color: white;
}
.service-desc{
  color: white;
  background: #19442A;
}
.pic-desc-container{
  width: 70%;
  margin: auto;
}
.logo{
  width: 300px;
}
</style>